import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import Footer from "../components/footer";
import Header from "../components/header";
import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import Accordion from "../components/Accordion";
import { CartContext } from "../../../contexts/cartContext";
import { CurrencyContext } from "../../../contexts/currencyContext"; // Import context
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import RequestModal from "../components/RequestModal";
import LoaderHomePd from "../components/loaderHomePd";



const Artist = () => {

    const location = useLocation();
    //const { artistId } = location.state || {};

    const { artistNameAndId } = useParams();

    // Extract the title and ID
    const [artistName, artistId] = artistNameAndId.split(/-(?=\d+$)/); // Split by the last '-' before the ID


    const [wishlists, setWishlists] = useState([]);
    const { wishlist, addToWishlist } = useContext(CartContext);

    const [artistDetails, setArtistDetails] = useState([]);
    const [artworkList, setArtworklist] = useState([]);
    const [soldArtworkList, setSoldArtworklist] = useState([]);
    const [loading, setLoading] = useState(true);
    const { currencyContxt } = useContext(CurrencyContext); // Use context

    const getArtistDetails = async () => {
        try {
            const response = await axios.get('https://igapi.heuristticminds.com/api/UserInterface/Get-GetArtistDetailsByArtistID?artist_id=' + artistId)
            setArtistDetails(response.data);
        }
        catch (error) {
            console.log(error)
        }
    };

    const getArtworkAll = async () => {
        debugger;
        try {
            const response = await axios.get('https://igapi.heuristticminds.com/api/UserInterface/Get-GetSimilarArtworkByArtistID?artist_id=' + artistId + '&product_id=0');
            setLoading(true);
            const delay = new Promise(resolve => setTimeout(resolve, 500)); // 500 ms delay
            await delay;

            setArtworklist(response.data);
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }

    }
    const getSoldArtworkAll = async () => {
        debugger;
        try {
            const response = await axios.get('https://igapi.heuristticminds.com/api/UserInterface/Get-GetSoldArtworkByArtistID?artist_id=' + artistId);
            setLoading(true);
            const delay = new Promise(resolve => setTimeout(resolve, 500)); // 500 ms delay
            await delay;

            setSoldArtworklist(response.data);
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }

    }

    //Wishlist Click
    const userInfo = JSON.parse(localStorage.getItem('user-info'));
    // Fetch the wishlist data when the page loads
    const fetchWishlistData = async () => {
                
        if (userInfo && userInfo.buyer_id) {
            try {
                const response = await fetch(`https://igapi.heuristticminds.com/api/WishList/Get-GetWishListByUserID?user_id=${userInfo.buyer_id}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const wishlistData = await response.json();

                if (wishlistData && Array.isArray(wishlistData)) {
                    setWishlists(wishlistData); // Store complete wishlist items from API
                } else {
                    setWishlists([]); // Set an empty wishlist if no data is returned
                }

            } catch (error) {
                console.error('Error fetching wishlist:', error);
            }
        } else {
            const localWishlist = getWishlistFromLocalStorage();
            setWishlists(localWishlist); // Store complete wishlist items from local storage
        }
    };

    // Handler for Wishlist Button Click
    const handleWishlistClick = async(item) => {
        
        const itemIsInWishlist = isInWishlist(item.product_id);

        if (userInfo && userInfo.buyer_id) {

            try {
                const payload = {
                    customer_id: userInfo.buyer_id,
                    product_id: item.product_id,
                };
                    const response = await fetch("https://igapi.heuristticminds.com/api/WishList/Add-SaveWishList", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(payload),
                });
                    
                if (!response.ok) {
                    throw new Error(`Failed to update wishlist: ${response.statusText}`);
                }
    
                // Extract JSON data from the response
                const { action } = await response.json(); // Destructuring to get action flag
    
    
                // Display success message based on the action performed
                if (action === "Add") {
                    toast.success("Artwork Added to Wishlist !!");
                } else if (action === "Remove") {
                    toast.error("Artwork Removed from Wishlist !!");
                }
                    // Fetch the updated wishlist after modification
                    await fetchWishlistData();  // Refresh state with the updated wishlist from the database
            } catch (error) {
                console.error("Error syncing wishlist item:", item.product_id, error);
            }
        }
        else{
            if (itemIsInWishlist) {
                // Remove from wishlist logic
                removeFromWishlist(item.product_id);
                toast.error("Artwork Removed from Wishlist 2 !!");
            } else {
                addToWishlist(item);
                toast.success("Artwork Added to Wishlist !!");
            }
        }
        

        handleWishlistUpdate(); // Refresh wishlist state after adding/removing
    };

    // Helper function to get wishlist from localStorage
    const getWishlistFromLocalStorage = () => {
        return JSON.parse(localStorage.getItem('wishlist')) || [];
    };

    // Context or state management function
    const handleWishlistUpdate = () => {
        
        if (userInfo && userInfo.buyer_id) {
            fetchWishlistData(); // Fetch from API
        } else {
            const updatedWishlist = getWishlistFromLocalStorage(); // Fetch from local storage
            setWishlists(updatedWishlist); // Update state
        }        
    };
    const isInWishlist = (productId) => {
        return wishlists.some(item => item.product_id === productId);
    };

    // Function to remove item from the wishlist
    const removeFromWishlist = (productId) => {
        const updatedWishlist = wishlists.filter(item => item.product_id !== productId);
        setWishlists(updatedWishlist); // Update state
        localStorage.setItem('wishlist', JSON.stringify(updatedWishlist)); // Update local storage
    };

    useEffect(() => {
        const loadWishlist = async () => {
            await fetchWishlistData();
        };
        loadWishlist();
    }, []);
    useEffect(() => {
        setWishlists(wishlist);
    }, [wishlist]); // This will trigger every time the wishlist state changes


    //WishList Click ends

    const columns = [
        {
            cell: (row) => {
                const isInWishlist = wishlists.some(item => item.product_id === row.product_id);
                return (
                    <div className="pd_item" key={row.product_id}>
                        <div className="img_box">
                            <img src={`../images/products/thumbnail/${row.image}`} className="pd_img" alt="" />
                            <a href="#" className="wishlist_link" title="WISHLIST" onClick={(e) => {
                                e.preventDefault();
                                //addToWishlist(row); // Add or remove item from wishlist
                                handleWishlistClick(row); // Updated function
                            }}>
                                <i className={`${isInWishlist ? 'bi bi-suit-heart-fill text-danger' : 'bi bi-suit-heart'}`}></i>
                            </a>
                            <span className="q_view" onClick={() => handleDetails(row.product_id, row.productTitle)}><i className="bi bi-eye"></i> Quick View</span>
                            <span className="size">Size: <b>{row.size}</b></span>
                        </div>
                        <div className="pd_content">
                            <span className="pd_brand">{row.productTitle}</span>
                            <span className="pd_title">{row.category}: {row.categoryType}</span>
                            {
                                row?.price_on_demand === 1 ? <><span className="btn_req" onClick={() => handleRequestPrice(row?.product_id, row?.productTitle)}>Request Price</span></> :

                                    <div className="Price">
                                        {currencyContxt.icon} {(row?.price / currencyContxt.value).toFixed(2)}
                                        {
                                            row?.discountRate === 0 ? ''
                                                : <>
                                                    <span className="old_price">{currencyContxt.icon} {(row?.gstMRP / currencyContxt.value).toFixed(2)}</span><span className="discount">({row?.discountRate}%)</span>
                                                </>
                                        }
                                        {
                                            currencyContxt.currency == "INR" ?
                                                <small>Including GST</small>
                                                :
                                                <></>
                                        }
                                    </div>
                            }
                        </div>
                    </div>
                )
            }
        },
    ];
    const paginationComponentOptions = {
        noRowsPerPage: true
    };
    const columnsSold = [
        {
            cell: (row) => {
                
                return (
                    <div className="pd_item" key={row.product_id}>
                        <div className="img_box">
                        <div className={`${row.status === 3 ? 'soldout' : row.status === 5 ? 'soldbyartist' : ''}`} ><img src={`../images/products/thumbnail/${row.image}`} className="pd_img" alt="" /></div>
                            
                            <span className="q_view" onClick={() => handleDetails(row.product_id, row.productTitle)}><i className="bi bi-eye"></i> Quick View</span>
                            <span className="size">Size: <b>{row.size}</b></span>
                        </div>
                        <div className="pd_content">
                            <span className="pd_brand">{row.productTitle}</span>
                            <span className="pd_title">{row.category}: {row.categoryType}</span>
                            {
                                row?.price_on_demand === 1 ? <><span className="btn_req" onClick={() => handleRequestPrice(row?.product_id, row?.productTitle)}>Request Price</span></> :

                                    <div className="Price">
                                        {currencyContxt.icon} {(row?.price / currencyContxt.value).toFixed(2)}
                                        {
                                            row?.discountRate === 0 ? ''
                                                : <>
                                                    <span className="old_price">{currencyContxt.icon} {(row?.mrp / currencyContxt.value).toFixed(2)}</span><span className="discount">({row?.discountRate}%)</span>
                                                </>
                                        }
                                        {
                                            currencyContxt.currency == "INR" ?
                                                <small>Including GST</small>
                                                :
                                                <></>
                                        }
                                    </div>
                            }
                        </div>
                    </div>
                )
            }
        },
    ];
    

    const navigate = useNavigate();
    const handleDetails = (id, productTitle) => {
        const formattedTitle = productTitle.replace(/ /g, '-'); // Replace spaces with '-'
        navigate(`/artwork/${formattedTitle}-${id}`, { state: { id: id}});
        window.scrollTo({
            top: 0,
            behavior: "instant"
        });
    };

    const items = artistDetails.length > 0 ? [
        ...(artistDetails[0]?.awards?.trim() // Check if `awards` is not empty
        ? [{
            title: 'Award Details',
            content: <div dangerouslySetInnerHTML={{ __html: artistDetails[0]?.awards }} />,
          }]
        : []),
        ...(artistDetails[0]?.shows?.trim() // Check if `awards` is not empty
        ? [{
            title: 'Art Show Details',
            content: <div dangerouslySetInnerHTML={{ __html: artistDetails[0]?.shows }} />,
          }]
        : []),
        ...(artistDetails[0]?.artistDetails?.trim() // Check if `awards` is not empty
        ? [{
            title: `More About ${artistDetails[0]?.artistName}`,
            content: <div dangerouslySetInnerHTML={{ __html: artistDetails[0]?.artistDetails }} />,
          }]
        : []),        
    ] : [];

    useEffect(() => {
        getArtistDetails();
        getArtworkAll();
        getSoldArtworkAll()
    }, [artistId]);


    //const selectedCurrency = JSON.parse(localStorage.getItem('selectedCurrency'));
    const [isModalOpen, setModalOpen] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [selectedPd, setSelectedPd] = useState(null);

    const handleRequestPrice = (id, pdTitle) => {
        setModalOpen(true);
        setSelectedId(id);
        setSelectedPd(pdTitle);
    };

    const handleCloseModal = () => {
        setModalOpen(false);
        setSelectedId(null);
        setSelectedPd(null);
    };

    return (
        <>
            <Header />
            <div style={{ marginTop: '150px' }}>
                <div className="container">

                    <div className="row">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-4">
                                <li className="breadcrumb-item"><Link to={'/'}>Home</Link></li>
                                <li className="breadcrumb-item"><Link to={'/'}>Artist</Link></li>
                                <li className="breadcrumb-item">{artistDetails[0]?.artistName}</li>
                            </ol>
                        </nav>
                        <div className="col-md-5 mb-5 text-center">
                            <div className="artist_pic">
                                <img className="img_artist" src={`../images/profile/${artistDetails[0]?.image}`} alt="" />
                                <div className="picdot">
                                    <img className="img-fluid" src="../images/dots-1.svg" alt="" />
                                </div>
                            </div>


                        </div>
                        <div className="col-md-7 overflow-hidden">
                            <h3 className="sec_title">ABOUT VISUAL ARTIST</h3>
                            <h4 className="display-6">{artistDetails[0]?.artistName}</h4>
                            <p><i className="bi bi-geo-alt-fill"></i> {artistDetails[0]?.city}</p>
                            <Accordion items={items} />
                            <br />
                        </div>

                        <hr />
                        <div className="col-md-12">
                            <h3><b>{artistDetails[0]?.artistName}'s</b> ARTWORKS/PAINTING FOR SALE </h3>
                        </div>
                        <div className="col-md-12 pd-list">
                            {
                                loading ? (<LoaderHomePd />
                                ) : (
                                    <DataTable
                                        columns={columns}
                                        data={artworkList}
                                        pagination
                                        noTableHead
                                        paginationComponentOptions={paginationComponentOptions}
                                        paginationPerPage={[20]}
                                    />
                                )}

                        </div>
                        <hr />
                        {soldArtworkList && soldArtworkList.length > 0 && (
                            <div>
                        <div className="col-md-12">
                            <h3><b>{artistDetails[0]?.artistName}'s</b> SOLD ARTWORKS </h3>
                        </div>
                        <div className="col-md-12 pd-list">
                            {
                                loading ? (<LoaderHomePd />
                                ) : (
                                    <DataTable
                                        columns={columnsSold}
                                        data={soldArtworkList}
                                        pagination
                                        noTableHead
                                        paginationComponentOptions={paginationComponentOptions}
                                        paginationPerPage={[20]}
                                    />
                                )}

                        </div>
                        </div>
                        )}

                    </div>

                </div>
            </div>
            <ToastContainer position="bottom-right" />
            <RequestModal isOpen={isModalOpen} onClose={handleCloseModal} id={selectedId} pdTitle={selectedPd} />
            <Footer />
        </>
    )
}
export default Artist;